__turbopack_context__.v({
  "breadcrumbs_container": "Footer-module-scss-module__L1goVG__breadcrumbs_container",
  "divider": "Footer-module-scss-module__L1goVG__divider",
  "footer_container": "Footer-module-scss-module__L1goVG__footer_container",
  "footer_content": "Footer-module-scss-module__L1goVG__footer_content",
});
